import React from 'react';
import { Sidebar, Menu, MenuItem, useProSidebar } from 'react-pro-sidebar';
import ReactReveal from 'react-reveal';
import { Link } from 'react-router-dom';
import { Typewriter } from 'react-simple-typewriter';
import './Cover.css'




const Cover = () => {
    const { collapseSidebar } = useProSidebar();


    return (
      <ReactReveal>
            <div className='cover'>
     <div className='mainbody'>
          <div className='flex justify-center items-center h-screen flex-col'>


            <h2 className='text-4xl text-white'>Hi, I am <span className='text-orange-400'>Bijon Talukder</span> <br></br>

              <span className='text-orange-300'>
                {/* Style will be inherited from the parent element */}
                <Typewriter
                  words={['MERN Stack Developer', 'Web Designer', 'Android Developer', 'Competitive Programming']}
                  loop={100}
                  cursor
                  cursorStyle='_'
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}
                // onLoopDone={handleDone}
                // onType={handleType}
                />
              </span>

            </h2>
            <p className=' text-white text-xl'>I am expert in  React Js, JavaScript, ES6, REST API, Firebase, Node Js,React Query, React Router 6 ,<br /> React Bootstrap, Bootstrap, HTML5, CSS3, Tailwind CSS, Daisy UI, Material UI,</p>


            <div className='my-7'>
              <a target='_blank' href='https://drive.google.com/file/d/1VNMvTbEeZZ5_pPoufysJnNeWciwaKIu1/view?usp=share_link' className="btn btn-outline btn-warning">Resume</a>
             <Link to={'/contact'}>              <button class="btn btn-outline btn-warning mx-6">Contact Me</button>
</Link>


            </div>
          </div>






        </div>
        </div>

      </ReactReveal>
    
    );
};

export default Cover;